import { render, staticRenderFns } from "./remitmoney_detail.vue?vue&type=template&id=640d1448&scoped=true"
import script from "./remitmoney_detail.vue?vue&type=script&lang=js"
export * from "./remitmoney_detail.vue?vue&type=script&lang=js"
import style0 from "./remitmoney_detail.vue?vue&type=style&index=0&id=640d1448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d1448",
  null
  
)

export default component.exports